import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'OAKeyValue' })
export class ObjectArrayKeyValuePipe implements PipeTransform {
	transform(array: Array<any>, key: string) {
		return array?.map((item) => item[key]);
	}
}
